export const CALGARY_CODE = '1'
export const QUEBEC_CODE = '2'
export const VANCOUVER_CODE = '3'
export const LONDON_CODE = '4'
